import React from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { addPopup, setMegaMenuId } from '../../../../redux/actions';
import * as popups from '../../../../constants/popup-types';
import * as routes from '../../../../constants/routes';
import { getMediaPath, sortArrayByKey } from '../../../../app/functions';
import MegaMenuItem from '../mega-menu-item';
import arrowDownIcon from '../../../../assets/icons/arrow-down-black.svg';
import appIcon from '../../../../assets/icons/app-download-black.svg';
import newsletterIcon from '../../../../assets/icons/newsletter-icon.svg';
import './index.scss';

const MegaMenuStrip = () => {
    const history = useHistory();
    const dispatch = useDispatch();

    const userData = useSelector((state) => state.config.UserData);
    const translations = useSelector((store) => store.config.Translations);
    const megaMenu = useSelector((store) => store.config.megaMenu);
    const appPopup = useSelector((store) => store.config.PopTrans.application);

    // Should be displayed if the user is not logged-in, or didn't join the newsletter (both by phone and email)
    const displayNewsletterButton = !userData || !userData.maStatus;

    const onMenuItemClick = (id, state) => {
        if (state) {
            dispatch(setMegaMenuId(id));
        } else {
            dispatch(setMegaMenuId(null));
        }
    };

    const handleDownloadApp = () => {
        dispatch(addPopup({
            type: popups.IMAGE_POPUP,
            image: { src: getMediaPath(appPopup.image), alt: translations['mega_menu_hot_app'] },
        }));
    };

    const handleJoinNewsletter = () => {
        const footerNewsletterElement = document.querySelector('#footer-newsletter');

        if (footerNewsletterElement) {
            // Element found, scroll to it
            footerNewsletterElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else {
            // Element not found, scroll to the bottom of the page
            window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth', block: 'center' });
        }
    };

    return (
        <div className="mega-menu-strip-wrapper">
            <MegaMenuItem
                id={0}
                text={translations['mega_menu_shopping_categories']}
                icon={arrowDownIcon}
                onClick={onMenuItemClick}
                hover
            />

            <MegaMenuItem
                id={2}
                text={translations['mega_menu_actions']}
                icon={arrowDownIcon}
                onClick={onMenuItemClick}
                hover
            />

            <MegaMenuItem
                id={1}
                text={translations['mega_menu_smart_consumption']}
                icon={arrowDownIcon}
                onClick={onMenuItemClick}
                hover
            />

            {sortArrayByKey(Object.values(megaMenu['links'])).map((linkData) => (
                <MegaMenuItem
                    key={`mega-menu-link_${linkData.id}`}
                    text={linkData.title}
                    onClick={() => {
                        if (linkData.link) {
                            if (linkData.link.type === 'external') {
                                if (linkData.link.route.startsWith(window.location.origin))
                                    window.location = linkData.link.route
                                else window.open(linkData.link.route);
                            } else {
                                history.push(routes[linkData.link.route]);
                            }
                        }
                    }}
                />
            ))}


            <MegaMenuItem
                text={translations['mega_menu_hot_app']}
                icon={appIcon}
                direction="ltr"
                iconClassName="app-icon"
                textClassName="bold"
                onClick={handleDownloadApp}
            />

            {displayNewsletterButton && (
                <MegaMenuItem
                    text={translations['mega_menu_join_newsletter']}
                    icon={newsletterIcon}
                    direction="ltr"
                    iconClassName="newsletter-icon"
                    textClassName="bold"
                    onClick={handleJoinNewsletter}
                />
            )}
        </div>
    );
};

export default MegaMenuStrip;
